import t from "./translations";

const relativeTimeFormat = new Intl.RelativeTimeFormat("en", {
  numeric: "auto",
});

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 24 * 60 * 60],
  ["month", 30 * 24 * 60 * 60],
  ["day", 24 * 60 * 60],
  ["hour", 60 * 60],
  ["minute", 60],
];

export function formatRelativeTime(date: Date, now: Date): string {
  const elapsedSeconds = Math.max(
    0,
    Math.round((now.getTime() - date.getTime()) / 1000)
  );
  for (const [unit, unitSeconds] of UNITS) {
    if (elapsedSeconds >= unitSeconds) {
      return relativeTimeFormat.format(
        -Math.floor(elapsedSeconds / unitSeconds),
        unit
      );
    }
  }
  return t.JustNow;
}
